import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { tap } from 'rxjs';

const REQUEST_ID_HEADER = 'X-Request-Id';
const REQUEST_ID_STORAGE_KEY = 'request_id';

function readRequestId(): string | null {
  try {
    return sessionStorage.getItem(REQUEST_ID_STORAGE_KEY);
  } catch {
    return null;
  }
}

function saveRequestId(requestId: string): void {
  try {
    sessionStorage.setItem(REQUEST_ID_STORAGE_KEY, requestId);
  } catch {
    return;
  }
}

function createRequestId(): string {
  return globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`;
}

function getOrCreateRequestId(): string {
  const requestId = readRequestId();
  if (requestId) {
    return requestId;
  }

  const newRequestId = createRequestId();
  saveRequestId(newRequestId);
  return newRequestId;
}

function persistResponseRequestId(response: HttpResponse<unknown> | HttpErrorResponse): void {
  const requestId = response.headers.get(REQUEST_ID_HEADER);
  if (requestId) {
    saveRequestId(requestId);
  }
}

export const httpRequestIdInterceptor: HttpInterceptorFn = (req, next) => {
  const requestId = req.headers.get(REQUEST_ID_HEADER) ?? getOrCreateRequestId();
  saveRequestId(requestId);

  const requestWithId = req.headers.has(REQUEST_ID_HEADER)
    ? req
    : req.clone({
        setHeaders: {
          [REQUEST_ID_HEADER]: requestId,
        },
      });

  return next(requestWithId).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          persistResponseRequestId(event);
        }
      },
      error: (error) => {
        if (error instanceof HttpErrorResponse) {
          persistResponseRequestId(error);
        }
      },
    }),
  );
};
